import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import QAElement from 'components/QAElement';
import KButton from 'components/KJRN/KButton';
import KTitle from 'components/KJRN/KTitle';
import Loading from 'components/Loading';
import PanelMessage from 'components/panels/PanelMessage';

import { FormattedMessage } from 'react-intl';
import { fetchQuestionnaire, submitQuestionnaire } from 'actions/CourseQuestionnaire';

import flowRight from 'lodash/flowRight';
import map from 'lodash/map';

const validate = (values, props) => {
  const error = {};
  const { questionnaire } = props;
  if (!questionnaire) { return error; }
  const questions = questionnaire.QAElements.filter(q => q.QAElementType === 3);

  map(questions, ({
    QAElementID,
    QAInput,
    MinAnswers,
  }) => {
    /* No validation on checkbox questions */
    if (QAInput.QAInputAnswerType === 3) { return; }
    const key = `${QAInput.QAInputAnswerType}-${QAElementID}`;
    /* First check if element is equired */
    if (MinAnswers > 0 && !values[key]) {
      error[key] = 'Þetta svæði verður að vera útfyllt';
    /* Second check if element has mask */
    } else if (QAInput && QAInput.QAMaskEntity) {
      if (QAInput.QAInputAnswerType === 5) { return; }
      const { QAMaskString, QAMaskDescription } = QAInput.QAMaskEntity;
      /* Create regex for the mask */
      const re = new RegExp(QAMaskString, 'i');
      if (!re.test(values[key])) {
        error[key] = QAMaskDescription;
      }
    }
  });

  return error;
};

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.fetch();
  }

  submit = (data, dispatch) => dispatch(submitQuestionnaire(data, this.props.onSuccess));

  render() {
    const {
      questionnaire,
      handleSubmit,
      invalid,
      isSubmitted,
      questionnaireError,
      submitFailed,
    } = this.props;

    if (questionnaireError) {
      return <PanelMessage message={questionnaireError.message || questionnaireError.Message} type="error" iconName="error" />;
    }

    if (!questionnaire) {
      return <Loading />;
    }

    return (
      <div>
        <KTitle title={<FormattedMessage id="questionnaire.title" />} />
        <form>
          {questionnaire.QAElements.map(e =>
            (<QAElement
              key={e.QAElementID}
              {...e}
            />))}
          {submitFailed &&
            <PanelMessage message={<FormattedMessage id="questionnaire.submitFailed" />} type="warning" iconName="warning" />
          }
          <KButton
            onClick={handleSubmit(this.submit)}
            disabled={invalid || isSubmitted}
            label={<FormattedMessage id="questionnaire.submit" />}
          />
        </form>
      </div>
    );
  }
}

/**
 * Props
 * - onSaveSuccess
 * - onSaveFailure
 * - QuestionnaireRootID
 */

Questionnaire.propTypes = {
  questionnaireRootID: PropTypes.number,
  questionnaire: PropTypes.shape({
    QAElements: PropTypes.array,
    QAElementID: PropTypes.number,
    QAElement: PropTypes.object,
  }),
  questionnaireError: PropTypes.shape({
    message: PropTypes.string,
    Message: PropTypes.string,
  }),
  onSuccess: PropTypes.func,
  fetch: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool,
  invalid: PropTypes.bool,
  submitFailed: PropTypes.bool,
};

export default flowRight(
  connect(
    state => ({ ...state.CourseQuestionnaireReducer, initialValues: {} }),
    (dispatch, props) => ({
      fetch: () => dispatch(fetchQuestionnaire(props.questionnaireRootID, props.onSuccess)),
    }),
  ),
  reduxForm({
    form: 'questionnaire',
    validate,
    shouldValidate: () => true,
  }),
)(Questionnaire);



// WEBPACK FOOTER //
// ./src/containers/Questionnaire.js